import store from '@/store';
import { format, utcToZonedTime } from 'date-fns-tz';

const formatTimezoned = (date, pattern, timezone) => {
  const timeZoned = utcToZonedTime(date, timezone);
  return format(timeZoned, pattern);
};

const convertDateToUTC = (date) => new Date(date.getUTCFullYear(), date.getUTCMonth(),
  date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());

export default {
  methods: {
    parseDate(date) {
      if (!date) return null;
      return format(convertDateToUTC(date), 'yyyy-MM-dd');
    },

    parseDateTime(date) {
      if (!date) return null;
      return format(convertDateToUTC(date), 'yyyy-MM-dd HH:mm');
    },
  },
  filters: {
    readableDateTime(date) {
      if (!date) return '';
      return formatTimezoned(new Date(date), 'HH:mm dd.MM.yyyy', store.getters['auth/timezone']);
    },

    readableDate(date) {
      if (!date) return '';
      return formatTimezoned(new Date(date), 'dd.MM.yyyy', store.getters['auth/timezone']);
    },

    readableTime(date) {
      if (!date) return '';
      return formatTimezoned(new Date(date), 'HH:mm', store.getters['auth/timezone']);
    },
  },
};
